import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getConversationMessageHistory } from "store/services/clientMessagingService";

export const useConversation = (conversationId, userId) => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [initialMessagesLoaded, setInitialMessagesLoaded] = useState(false);

  const messageListRef = useRef(null);
  const messagesEndRef = useRef(null);

  const conversationList = useSelector((state) => state.ClientMessaging.conversationList);
  const conversation = conversationList?.find(conv => conv.conversation_id === conversationId) || null;

  const fetchMessageHistory = async (lastMessageId) => {
    if (!conversationId) return;
    try {
      setLoading(true);
      await dispatch(getConversationMessageHistory(conversationId, lastMessageId));
    } catch (error) {
      console.error("Error fetching chat history:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleLoadPrevious = async () => {
    if (!conversation?.messages?.length || !messageListRef.current) return;

    const prevScrollHeight = messageListRef.current.scrollHeight;
    const oldestMessage = conversation.messages[0];

    await fetchMessageHistory(oldestMessage.id);

    requestAnimationFrame(() => {
      const newScrollHeight = messageListRef.current.scrollHeight;
      messageListRef.current.scrollTop = newScrollHeight - prevScrollHeight;
    });

    setShowLoadMore(false);
  };

  const handleScroll = () => {
    if (messageListRef.current?.scrollTop === 0) {
      setShowLoadMore(true);
    } else {
      setShowLoadMore(false);
    }
  };

  useEffect(() => {
    setHasScrolled(false);
  }, [conversationId]);

  // useEffect(() => {
  //   if (conversation?.messages?.length && !hasScrolled) {
  //     requestAnimationFrame(() => {
  //       messagesEndRef.current?.scrollIntoView();
  //       setHasScrolled(true);
  //     });
  //   }
  // }, [conversation?.messages?.length, hasScrolled, conversationId]);

  useEffect(() => {
    if (!conversation?.messages?.length) return;
  
    const lastMessage = conversation.messages[conversation.messages.length - 1];
    const isFromUser = Number(lastMessage?.sender_id) === Number(userId);
  
    if (!hasScrolled || isFromUser) {
      requestAnimationFrame(() => {
        messagesEndRef.current?.scrollIntoView();
        setHasScrolled(true);
      });
    }
  }, [conversation?.messages?.length, conversationId]);

  useEffect(() => {
    if (!conversationId) return;
    fetchMessageHistory();
  }, [conversationId]);

  return {
    conversation,
    isLoading,
    messageListRef,
    messagesEndRef,
    showLoadMore,
    handleScroll,
    handleLoadPrevious,
  };
};
